import React from 'react';
import clsx from 'clsx';
import useStyles from './style';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import * as locators from './locators';
import SharedSimilarSearchContent from '../../../components/organism/SharedSimilarSearchContent/SharedSimilarSearchContent';
import Box from '../../../components/molecules/Box';
import { getPreProcessedCardListData } from './preProcessData';
import { getComponentName, getPageName } from '../../../utils/getPageComponentInfo';
import { getUId } from '../../../../utils/utility';

const ExploreHotels = props => {
  const classes = useStyles(props);
  if (!(props.fields && props.fields.title && props.fields.title.value && props.fields.items && props.fields.items.length > 0)) {
    return null;
  }
  const { title, items } = props.fields;
  const cardList = getPreProcessedCardListData(items);
  const { params } = props || {};
  const uid = getUId(props)

  return (
    <Box className={clsx(classes.root, 'explore-hotels')} data-locator={locators.COMPONENT_NAME} uid={uid}>
      <div className='infographicsbgImage-moreLikethis'></div>
      <SharedSimilarSearchContent
        {...{ fields: { cardList, title, aspectRatioNeeded: true, pageName: getPageName(props), componentName: getComponentName(props) } }}
        ratio='3x2-m'
        data-locator={locators.COMPONENT_NAME}
      />
    </Box>
  );
};

export default withErrorBoundary(withSitecoreContext()(ExploreHotels));
